import React, { useState } from 'react';

import { useTheme } from 'styled-components';

import { IoMdArrowDropup, IoMdArrowDropdown } from 'react-icons/io';

import { Container, Content, Title, Right, Control } from './styles';

import { SubmenuProps } from './interface';

const Submenu: React.FC<SubmenuProps> = ({ children, icon, title }) => {
  const { colors } = useTheme();

  const [visible, setVisible] = useState(false);

  const toggleCollapse = () => {
    setVisible(!visible);
  };

  return (
    <Container>
      <Title>
        <Control
          onClick={toggleCollapse}
          className={visible ? 'enable' : 'disable'}
        >
          <Title className={visible ? 'enable' : 'disable'}>
            <i>{icon}</i>
            <span>{title}</span>
          </Title>
          <Right className={visible ? 'enable' : 'disable'}>
            {visible ? (
              <IoMdArrowDropup size={22} color={colors.IC1} />
            ) : (
              <IoMdArrowDropdown size={22} color={colors.IC1} />
            )}
          </Right>
        </Control>
      </Title>

      {visible ? (
        <Content className={visible ? 'enable' : 'disable'}>
          <>{children}</>
        </Content>
      ) : null}
    </Container>
  );
};

export default Submenu;
